import generics from "./generics/he"

const he = {
  ...generics,
  generics: {
    ...generics.generics,
    verse: "פסוק | פסוקים",
    link: "קישור | קישורים",
    media: "תמונה | תמונות",
    game: "משחק | משחקים",
    video: "סרטון | סרטונים",
    audio: "פודקסט | פודקסטים",
  },
  toasts: {
    error: "אירעה שגיאה",
    success: "הפעולה הושלמה",
    successStore: "היצירה הושלמה",
    successUpdate: "העריכה הושלמה",
    successDestroy: "המחיקה הושלמה",
  },
  messages: {
    title: "צור קשר/תרום ידע",
    emailField: "כתובת מייל",
    messageField: "תוכן",
    contact: "ליצור קשר",
    knowledge: "לתרום ידע",
    targetLabel: "ברצוני",
  },
  history: {
    title: "היסטוריית מיקומים",
    noHistory: "אין היסטוריה",
  },
  errors: {
    ...generics.errors,
    positionError:
      "כדי להפעיל את השירות, עליך להפעיל GPS או לאשר גישה למיקום שלך",
  },
}
export default he
